import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'auth0';
export const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const Auth0ParameterSchema = z.enum(['AUTH0_BASE_URL']);
export const Auth0ParameterEnum = Auth0ParameterSchema.enum;
export const ServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: serviceEventType(),
}));
